import src from "IMAGE";
export default { src, width: 1142, height: 538, blurWidth: 0, blurHeight: 0};
